// Generic camelCase <-> snake_case conversion utilities

function isObject(value: any): value is Record<string, any> {
    return value && typeof value === 'object' && !Array.isArray(value)
}

function toCamelCaseKey(key: string): string {
    return key.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase())
}

function toSnakeCaseKey(key: string): string {
    return key.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`)
}

export function toCamelCase(obj: any): any {
    if (Array.isArray(obj)) {
        return obj.map(toCamelCase)
    } else if (isObject(obj)) {
        const newObj: Record<string, any> = {}
        for (const key in obj) {
            if (!Object.prototype.hasOwnProperty.call(obj, key)) continue
            const newKey = toCamelCaseKey(key)
            newObj[newKey] = toCamelCase(obj[key])
        }
        return newObj
    }
    return obj
}

export function toSnakeCase(obj: any): any {
    if (Array.isArray(obj)) {
        return obj.map(toSnakeCase)
    } else if (isObject(obj)) {
        const newObj: Record<string, any> = {}
        for (const key in obj) {
            if (!Object.prototype.hasOwnProperty.call(obj, key)) continue
            const newKey = toSnakeCaseKey(key)
            newObj[newKey] = toSnakeCase(obj[key])
        }
        return newObj
    }
    return obj
} 
